import React, {useRef, useEffect} from "react";
import { Form } from 'antd';
import { addPlatform, editPlatform } from "../../stateManagement/actions/data";
import { useDispatch } from "react-redux";
import BasicFormButtons from "./basicFormButtons";
import InputFormField from "./inputFormField";

const PlatformForm = ({reloadData, platformData, onSubmitType = "add"}) => {

    // Form reference for resetting
    const formRef = useRef(null);
    const dispatch = useDispatch();

    //Reset form fields
    const handleReset = () => formRef.current?.resetFields();

    // Load platform data into form when editing
    useEffect(() => {
        if (platformData && formRef.current) {
            formRef.current.setFieldsValue(platformData);
        }
    }, [platformData]);

    // Handle form submission
    const onFinish = (values) => {
        if (onSubmitType === "add") {
            dispatch(addPlatform(values));
        } else {
            dispatch(editPlatform(platformData._id, { ...platformData, ...values}));
        }
        handleReset();
        reloadData();
    };

    return(
        <Form 
            layout="vertical" 
            ref={formRef} 
            onFinish={onFinish}
            initialValues={platformData || {}}
        >
            <InputFormField 
                label="Platform name (UI):" 
                name="platformProviderName"
            />
            <InputFormField 
                label="Platform name (report):" 
                name="reportProviderName"
            />
            <InputFormField 
                label="Net rev. share for ORTB:" 
                name="netRevenueForOpenAdjustment" 
                number={true}
            />
            <InputFormField 
                label="Net rev. share for deals:" 
                name="netRevenueForDealsAdjustment" 
                number={true}
                validation={false}
            />
            <InputFormField 
                label="Currency (EUR/USD):" 
                name="currency"
            />
            {/* <InputFormField 
                label="Main sheet name (report):" 
                name="mainSheetName"
            />
            <InputFormField 
                label="Header row (report):" 
                name="headersRow"
                number={true}
            />
            <InputFormField 
                label="Date column:" 
                name="dateColumn"
            />
            <InputFormField 
                label="Publisher column:" 
                name="publisherColumn"
            />
            <InputFormField 
                label="Website column:" 
                name="websiteColumn"
            />
            <InputFormField 
                label="Placement column:" 
                name="placementColumn"
            />
            <InputFormField 
                label="Placement group column:" 
                name="placementGroupColumn"
                validation={false}
            />
            <InputFormField 
                label="Auction type column:" 
                name="auctionTypeColumn"
                validation={false}
            />
            <InputFormField 
                label="Deal name column:" 
                name="dealNameColumn"
                validation={false}
            />
            <InputFormField 
                label="Media type column:" 
                name="mediaTypeColumn"
                validation={false}
            />
            <InputFormField 
                label="Ad requests column:" 
                name="adRequestColumn"
                validation={false}
            />
            <InputFormField 
                label="Impressions column:" 
                name="impressionsColumn"
            />
            <InputFormField 
                label="Viewable imps. column:" 
                name="viewableimpressionsColumn"
                validation={false}
            />
            <InputFormField 
                label="Revenue column:" 
                name="revenueColumn"
            />
            <InputFormField 
                label="CPM column:" 
                name="cpmColumn"
                validation={false}
            />
            <InputFormField 
                label="Clicks column:" 
                name="clicksColumn"
                validation={false}
            /> */}
            <BasicFormButtons handleReset={handleReset} noReset={onSubmitType === "edit" ? true : false}/>
        </Form>
    )
}

export default PlatformForm;